import { z } from 'zod';
import { CampaignSocialMediaType, SocialAccountType } from '@anytag/graphql';
import { AllTranslationKeys } from '@anytag/shared-assets';
import { BaseValidations } from '@anytag/shared-validations';

// TODO: Update translation key to AllTranslationKeys.Error.<message> instead of AllTranslationKeys.<message>
export const EngagementPostSchema = z.object({
  id: z.number().optional(),
  postUrl: z.string(),
  content: z.string(),
  isTtcmForm: z.boolean(),
  insightUrls: z.array(z.string()),
  materialsUrl: z.array(z.string()),
  insightDataAcquisition: z.string(),
  influencerId: z.string().min(1, AllTranslationKeys.requiredInfluencerMessage),
  // Social account field
  socialAccountId: z.string(),
  socialAccountMedia: z.nativeEnum(SocialAccountType).or(z.literal('')),
  selectedAccount: z.string().min(1, AllTranslationKeys.requiredSocialAccountId),
  socialPostMedia: z.nativeEnum(CampaignSocialMediaType).or(z.literal('')),
  // override metrics fields
  likes: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  comments: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  saves: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  reach: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  views: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  impressions: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  shares: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  totalPlayTime: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  fullVideoViews: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  dislikes: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  avgWatchTimes: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  avgPlayRate: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  detailExpands: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  audienceRetention: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema,
  impressionsClickThroughRate: BaseValidations.MatchPositiveDecimalOrEmptyStringSchema
});
